import {Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfirmationService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {HttpService} from '../../../services/apiServices/http-service.service';
import {VirtualPrinterService} from '../../../services/apiServices/business/virtual-printer.service';
import {User} from '../../../model/user';
import {ApiConst} from '../../../services/apiServices/api-const';
import {FileSaverService} from 'ngx-filesaver';
import {CommonService} from '../../../services/apiServices/business/common.service';

@Component({
  selector: 'app-download-virtual-printer',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DownloadVirtualPrinterComponent implements OnInit, OnChanges {
  public disableVirtualPrinterButton: boolean;
  public doUploadVirtualPrinter: boolean;
  public releaseRegExp: RegExp;
  public releaseValue: string;
  public downloadableList: [];
  public cols: any[];
  public headerMsg: string;
  public noDownloadMsg: string;
  public virtualPrinterType: string;
  public displayFormToDownload: boolean;
  public version: string;
  public name: string;
  public date: string;
  public size_x32: string;
  public size_x64: string;
  public comment: string;
  public delete_confirm_title: string;
  public delete_confirm_body: string;
  public deleted_title: string;
  public deleted_body: string;
  public error_title: string;
  public error_body: string;

  @Input()
  public user: User;
  @Input()
  public displayUploadVirtualPrinterPanel: boolean;
  @Input()
  public virtualPrinterList: [];
  @Input()
  public virtualPrinterPackageList: [];
  @Output()
  public updateDownloadableList = new EventEmitter();

  constructor(  private http: HttpClient, private httpService: HttpService,
                private fileSaverService: FileSaverService,
                private translate: TranslateService, private confirmationService: ConfirmationService,
                private virtualPrinterService: VirtualPrinterService, private commonService: CommonService) {
    this.disableVirtualPrinterButton = true;
    this.doUploadVirtualPrinter = false;
    this.releaseRegExp = new RegExp( '[0-9]{1,3}' );
    this.releaseValue = '';
    this.displayFormToDownload = false;
  }

  public ngOnInit(): void {
    this.getTraductions();
  }

  public ngOnChanges(): void {

    if ( this.virtualPrinterPackageList && this.virtualPrinterPackageList.length > 0 ) {
      this.cols = [
        { field: 'release', header: this.version },
        { field: 'name', header: this.name },
        { field: 'date', header: this.date },
      ];

      this.virtualPrinterType = 'package';
      this.headerMsg = 'APPLICATION.CONTAINER_COMPONENT.MODAL_DOWNLOAD_SPECIFIC_VIRTUAL_PRINTER';
      this.downloadableList = this.virtualPrinterPackageList;
    } else {
      this.cols = [
        { field: 'release', header: this.version },
        { field: 'size_x64', header: this.size_x32 },
        { field: 'size_x32', header: this.size_x64 },
        { field: 'releaseNotes', header: this.comment },
        { field: 'date', header: this.date }
      ];

      this.virtualPrinterType = 'generic';
      this.headerMsg = 'APPLICATION.CONTAINER_COMPONENT.MODAL_DOWNLOAD_GENERIC_VIRTUAL_PRINTER';
      this.downloadableList = this.virtualPrinterList;
    }
  }

  public getTraductions(): void {
    this.translate.get('VIRTUAL_PRINTER.COMMON.VERSION').subscribe((res: string) => {
      this.version = res;
    });
    this.translate.get('VIRTUAL_PRINTER.COMMON.NAME').subscribe((res: string) => {
      this.name = res;
    });
    this.translate.get('VIRTUAL_PRINTER.COMMON.VIRTUAL_PRINTER_SIZE_x32' ).subscribe((res: string) => {
      this.size_x32 = res;
    });
    this.translate.get('VIRTUAL_PRINTER.COMMON.VIRTUAL_PRINTER_SIZE_x64' ).subscribe((res: string) => {
      this.size_x64 = res;
    });
    this.translate.get('VIRTUAL_PRINTER.COMMON.COMMENT' ).subscribe((res: string) => {
      this.comment = res;
    });
    this.translate.get('VIRTUAL_PRINTER.COMMON.DATE' ).subscribe((res: string) => {
      this.date = res;
    });
    this.translate.get('VIRTUAL_PRINTER.CONFIRM_DELETE.CONFIRM_DELETE_TITLE' ).subscribe((res: string) => {
      this.delete_confirm_title = res;
    });
    this.translate.get('VIRTUAL_PRINTER.CONFIRM_DELETE.CONFIRM_DELETE_BODY' ).subscribe((res: string) => {
      this.delete_confirm_body = res;
    });
    this.translate.get('VIRTUAL_PRINTER.CONFIRM_DELETE.DELETED_TITLE' ).subscribe((res: string) => {
      this.deleted_title = res;
    });
    this.translate.get('VIRTUAL_PRINTER.CONFIRM_DELETE.DELETED_BODY' ).subscribe((res: string) => {
      this.deleted_body = res;
    });
    this.translate.get('VIRTUAL_PRINTER.CONFIRM_DELETE.ERROR_TITLE' ).subscribe((res: string) => {
      this.error_title = res;
    });
    this.translate.get('VIRTUAL_PRINTER.CONFIRM_DELETE.ERROR_BODY' ).subscribe((res: string) => {
      this.error_body = res;
    });
    this.noDownloadMsg = 'APPLICATION.CONTAINER_COMPONENT.MODAL_DOWNLOAD_NO_PRINTER_AVAILABLE';
  }

  public setDisplayFormToDownload( event, rowData ) {
    this.displayFormToDownload = this.virtualPrinterType === 'generic';
    this.releaseValue = rowData.release;
  }

  public unsetDisplayFormToDownload( event ) {
    this.displayFormToDownload = false;
  }

  public confirmDelete( event, data ) {
    this.confirmationService.confirm({
      header: this.delete_confirm_title,
      icon: 'pi pi-info-circle',
      message: this.delete_confirm_body + ' ( ' + data.release + ' )',
      accept: () => {
        this.deleteVirtualPrinter( event, data );
      }
    });
  }

  public deleteVirtualPrinter(event, data): void {
    const that = this;

    let s,
      release,
      url;

    switch ( this.virtualPrinterType ) {
      case 'package':
         url = ApiConst.deleteCustomerInstallerPackage;

         data = {
          customerPackage: data.name
         };
        break;
      case 'generic':
        url = ApiConst.deletePrinterInstaller;
        s = event.path[ 3 ].innerText;
        release = s.match( '\\d+\\.\\d+\\.\\d+')[ 0 ];

        data = {
          release
        };
        break;
    }

    this.virtualPrinterService.deleteVirtualPrinter( url, data ).subscribe( response => {
      const r = response.body;

      if ( r.bOK ) {
        this.commonService.addToast({
          life: 5000,
          severity: 'success',
          summary: this.deleted_title,
          detail: this.deleted_body
        });

        this.virtualPrinterService.updateDownloadableList( );

      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.error_title,
          detail: this.error_body + ' ( ' + r.sMsgError + ' ).'
        });
      }

      this.updateDownloadableList.emit( true );
    });
  }

  public downloadPackagedVirtualPrinter( event, data, env, arch ): void {
    const that = this,
      postData = {
        customerPackage: data.name,
        environment: env,
        architecture: arch
      };

      this.virtualPrinterService.downloadVirtualPrinter( postData ).subscribe( response => {
        const h = response.headers.get('content-type');

        if (h.startsWith('application/zip')) {
          if (response.body.size > 0) {
          const fileName = response.headers.get('content-disposition').split(';')[1].split('=')[1];
          const blob = new Blob([ response.body ], {endings: 'native', type: response.headers.get('content-type')});
          this.fileSaverService.save(blob, fileName);
        } else {
          this.commonService.addToast({
            life: 5000,
            severity: 'error',
            summary: this.error_title,
            detail: this.error_body + ' ( ' + response.sMsgError + ' ).'
          });
        }
      } else if (h.startsWith('application/json')) {
        const reader = new FileReader();

        reader.onload = (e: any) => {
          const msg = JSON.parse((<any>e.target).result);

          this.commonService.addToast({
            life: 5000,
            severity: 'error',
            summary: this.error_title,
            detail: this.error_body + ' ( ' + msg.sMsgError + ' ).'
          });
        };

        reader.readAsText(response.body);
      }
    });
  }
}
